export class bookingSavePayload{
    scheduledSession:scheduledSession = new scheduledSession();
    scheduledSessionFormQuestions: scheduledSessionFormQuestions = new scheduledSessionFormQuestions();
    scheduledSessionPayment: scheduledSessionPayment = new scheduledSessionPayment();
    scheduledSessionCallbackStatus?: scheduledSessionCallbackStatus = new scheduledSessionCallbackStatus();
  }

  export class  scheduledSession {
    uuid: string = null // "505e4ec6-befa-4e72-a0c0-aa35b8d8d55d",
    ref_id?:string = null // "012345678",
    client_first_name:string = null // "John",
    client_last_name:string = null // "Doe",
    client_email:string = null // "john@example.com",
    phone_no:string = null // "+1234567890",
    phone_country_code:string = null // "+1",
    notes:string = null // "Additional notes for the session",
    appointment_start_time:string = null // "2025-02-10",
    session_time_slot_uuid:string = null // "d878c65b-77cc-472a-aa62-b7575dd1b39b",
    status: string = "InComplete"
    timezone:string = null // "Asia/Yekaterinburg"
  }

  export class  scheduledSessionFormQuestions {
    formData: any = null
    status:string = "Active"
  }

  export class  scheduledSessionPayment {
    card_number: string = null 
    cardholder_name: string = null
    cvv_code: string = null 
    exp_date: string = null 
    zip_code: string = null 
    card_type: string = null 
    last_four_digit: string = null 
    status: string = "Active" 
  }

  export class  scheduledSessionCallbackStatus {
    scheduled_session_uuid: string = null // "550e8400-e29b-41d4-a716-446655440000",
    callback_status: string = null // "PENDING",
    retry: number = null // 1,
    status: string = null // "Active"
  }

  export class RescheduleBooking{
    appointment_start_time: Date = null; //2025-02-10,
    session_time_slot_uuid: string = null// d878c65b-77cc-472a-aa62-b7575dd1b39b,
    timezone: string = null // +05:00
}

export class conflictPayload{
   userId:number = null;
   date :string = null //"2024-02-10"
}

export class bookingSuccessInput{
  bookingdata : scheduledSession = new scheduledSession();
  bookingduration : number = null;
  id: string = '';
  
}

export class ScheduledSession {
  client_first_name: string | null = null;
  client_last_name: string | null = null;
  client_email: string | null = null;
  phone_no: string | null = null;
  phone_country_code: string | null = null;
  appointment_start_time: string | Date | null = null;
  session_time_slot_uuid: string | null = null;
  timezone: string | null = null;
  uuid: string | null = null;
  amount: number | null = null;
  day_of_year: number | null = null;
  status: string | null = null;
  ref_id?: string | null = null;
  notes: string | null = null;
  created_at: string | Date | null = null;
  updated_at: string | Date | null = null;
}

export class ScheduledSessionFormQuestions {
  scheduled_session_uuid: string | null = null;
  formData: Record<string, any> = {};
  status: string | null = null;
  uuid: string | null = null;
}

export class ScheduledSessionCallbackStatus {
  uuid: string | null = null;
  scheduled_session_uuid: string | null = null;
  callback_status: string | null = null;
  status: string | null = null;
}

export class PostBackAPIMeta {
  api: string | null = null;
  version: string | null = null;
  applicationId: number | null = null;
  action: string | null = null;
  uri: string | null = null;
  executionTime: string | null = null;
}

export class PostBackAPIData {
  paymentMethod: string | null = null;
  paymentDate: string | Date | null = null;
  contact: string | null = null;
  transactionRef: string | null = null;
  amount: number | null = null;
  payorFirstName: string | null = null;
  payorLastName: string | null = null;
  payorEmail: string | null = null;
  additionalEmails: string | null = null;
  description: string | null = null;
  receivedBy: string | null = null;
  receiptNo: string | null = null;
}

export class PostBackAPIStatus {
  meta: PostBackAPIMeta = new PostBackAPIMeta();
  status: string | null = null;
  timestamp: string | Date | null = null;
  data: PostBackAPIData = new PostBackAPIData();
}

export class bookingSuccessResponse {
  scheduledSession: scheduledSession = new scheduledSession();
  scheduledSessionFormQuestions: ScheduledSessionFormQuestions = new ScheduledSessionFormQuestions();
  scheduledSessionPayment: any = null;
  scheduledSessionCallbackStatus: ScheduledSessionCallbackStatus = new ScheduledSessionCallbackStatus();
  postBackAPIStatus: PostBackAPIStatus = new PostBackAPIStatus();
}

export class CancelBookingPayload {
  subject: string = null;
  content: string = null;
  calendarEventIdentifier: string = null;
  issueRefund: boolean = null;
  includeZoomMeeting: boolean = null;
  includeGoogleMeeting: boolean = null;
  zoomUserId: string = null;
  zoomTimezone: string = null;
  activityType: string = null;
  existingContactId: number = null;
}

export class LollyBooking{
  uuid: string = null ;
  account_uuid: string = null
  account_ref_id: number = null; 
  account_session_uuid: string = "" ;
  account_session_ref_id: string ;
  account_session_name:string = null ;
  conflict_ref_id:number = null;
  calendar_event_identifier: string = null ;
  ref_id: string = null;
  client_first_name: string = null;
  client_last_name: string = null;
  phone_no: string = null;
  phone_country_code: string =null;
  calendar_name: string = null;
  client_email: string = "" ;
  amount: number = null
  target_bank_id: number = null;
  session_time_slot_uuid: string = null;
  notes: string = "";
  timezone: string = null ;
  appointment_start_time: Date;
  duration: number  = null ;
  status: 'Cancelled' | 'Confirmed' | 'Active' | 'InActive' = 'Active';
}